import React from "react"
import { Source, Layer } from "react-map-gl"
import type { CircleLayer as CircleLayerType } from "react-map-gl"
import type GeoJSON from "geojson"
import { Coord } from "../lib/helpers/map"

export const CIRCLE_LAYER_SUFFIX = "_circle_layer"

interface CirclePaint {
  circleColor?: string
  circleRadius?: number
  circleStrokeWidth?: number
  circleStrokeColor?: string
  circleOpacity?: number
}

interface CircleLayerProps {
  id: string
  center: Coord
  paint?: CirclePaint
  properties?: any
}

const CircleLayer: React.FC<CircleLayerProps> = ({ id, center, paint, properties }) => {
  const data = {
    type: "Feature",
    properties: properties ?? {},
    geometry: {
      type: "Point",
      coordinates: center,
    },
  } as GeoJSON.Feature

  const circleLayer: CircleLayerType = {
    id: `${id}${CIRCLE_LAYER_SUFFIX}`,
    type: "circle",
    paint: {
      "circle-color": paint?.circleColor ?? "#000",
      "circle-radius": paint?.circleRadius ?? 5,
      "circle-stroke-width": paint?.circleStrokeWidth ?? 0,
      "circle-stroke-color": paint?.circleStrokeColor ?? "#000",
      "circle-opacity": paint?.circleOpacity ?? 1,
    },
  }

  return (
    <Source type="geojson" data={data}>
      <Layer {...circleLayer} />
    </Source>
  )
}

export default CircleLayer
